export const workData = [
 {
    id:1,
    title: "FOOD GALLERY",
    img: "assets/reactimg.png",
    desc:"",
    link:"https://eloquent-sopapillas-c66afb.netlify.app/",
 },

 {
    id:2,
    title: "TRAVEL-PAGE",
    img: "assets/reactimg.png",
    desc:"",
    link:"https://dainty-naiad-2e833c.netlify.app/",
 },


 {
    id:3,
    title: "EVENTS",
    img: "assets/reactimg.png",
    desc:"",
    
    link:"https://celebrated-bombolone-0696b5.netlify.app/",
 },


 {
    id:4,
    title: "FLIP-BOX",
    img: "assets/reactimg.png",
    desc:"",
   
    link:"https://fastidious-toffee-64c423.netlify.app/",
 },




]